/**
 * StickerMediaItem 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StickerMediaItem
 */
export interface StickerMediaItem {
  /** URL */
  url?: string
  /** 宽度 */
  width?: number
  /** 高度 */
  height?: number
  /** 大小（字节） */
  size?: number
}

/**
 * StickerMediaItem Schema
 */
export const StickerMediaItemSchema: SchemaDefinition = {
  properties: {
    url: {
      description: 'URL',
      format: 'string',
      type: 'string',
      label: 'URL',
    },
    width: {
      description: '宽度',
      format: 'int',
      type: 'integer',
      label: '宽度',
    },
    height: {
      description: '高度',
      format: 'int',
      type: 'integer',
      label: '高度',
    },
    size: {
      description: '大小（字节）',
      format: 'int',
      type: 'integer',
      label: '大小',
    },
  },
  type: 'object',
}
